import React from 'react';
import bem from 'utils/bem';
import Icon from '../../../components/Icon';
//import Loading from 'components/Loading';
import { Autocomplete } from '@mui/material';

import './index.sass';

const { cnBlock, el } = bem('form-field', 'form-autocomplete');


const InputUnclassed = (props) => {
    const { InputProps, inputProps, loading, placeholder } = props;
    const { endAdornment } = InputProps;
    const clearIcon = endAdornment?.props?.children?.[0];
    return (
        <div ref={ InputProps.ref } className={ el('container') }>
            <input { ...inputProps }
                   placeholder={placeholder}
                   className={ el('autocomplete-input', { 'has-clear-icon': clearIcon, 'has-end-adornment': true }) }
                   type="text"/>
            <div className={el('icons')}>
                { clearIcon && <Icon className={ el('autocomplete-icon', 'clear') } name="x" onClick={clearIcon?.props?.onClick}/> }
                { loading ? 'loading' :
                    <Icon className={ el('autocomplete-icon', 'lupe') } name={'magnifying-glass'} /> }
            </div>
        </div>
    )
}

const InputFreeSolo = (props) => {
    const { InputProps, inputProps, placeholder } = props;
    const { endAdornment } = InputProps;
    const clearIcon = endAdornment?.props?.children?.[0];
    return (
        <div ref={ InputProps.ref } className={ el('container') }>
            <input { ...inputProps }
                   placeholder={placeholder}
                   className={ el('autocomplete-input', { 'has-clear-icon': clearIcon }) }
                   type="text"/>
            <div className={el('icons')}>
                { clearIcon && <Icon className={ el('autocomplete-icon', 'clear') } name="x" onClick={clearIcon?.props?.onClick}/> }
            </div>
        </div>
    )
}

export default ({ className, name, options, onBlur = () => {}, loading = false, placeholder = 'Выберите', mod = '', error, ...props }) => {

    const componentProps = {
        paper: {
            className: el('dropdown')
        }
    }

    const rInput = (inputProps) => {
        if (props.freeSolo) {
            return <InputFreeSolo {...inputProps} placeholder={placeholder} mod={mod} />
        } else {
            return <InputUnclassed {...inputProps} loading={loading} placeholder={placeholder} mod={mod} />
        }
    }

    return (
        <div className={ cnBlock(className, mod, { 'disabled': props.disabled }) }>
            <Autocomplete
                { ...props }
                componentsProps={ componentProps }
                renderInput={ rInput }
                options={ options }
                ListboxProps={ { className: el('list') } }
            />
            { error && <div className="form-error">{ error }</div> }
        </div>
    )
}
